import { css } from "@emotion/react";
import React from "react";

import { NavLI, NavMenu, Right } from "../../base";
import AccountWidget from "./AccountWidget";

const HeaderRight = () => (
  <Right
    css={css`
      flex: 0 0 auto;
      width: 25%;
    `}
  >
    <NavMenu right>
      <NavLI>
        <AccountWidget />
      </NavLI>
    </NavMenu>
  </Right>
);

export default HeaderRight;
